export const CATEGORIES = ["Jackets", "Hoodies & Sweatshirts", "T-Shirts", "Pants", "Knitwear", "Accessories"];
export const categorySlug = (c) => c.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-");
